'use strict'

const stringify = require('./stable')

module.exports = stringify
stringify.default = stringify
